import { render } from "./MassBulkCreateModal.vue?vue&type=template&id=0fe880e8"
import script from "./MassBulkCreateModal.vue?vue&type=script&lang=js"
export * from "./MassBulkCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__